import styles from "./MainNavigation.module.scss";
import { NavLink, Link } from "react-router-dom";
import colors from "../../styles/_colors.scss";
import Timer from "../Timer";

function MainNavigation() {
  return (
    <header className={styles.header}>
        <NavLink className={styles.logo} to="/">Swarm Story</NavLink>
      <nav>
        <ul>
          <li>
            <NavLink
              className={({ isActive }) => {
                return isActive ? styles.active : styles.inactive;
              }}
              to="/"
            >
              Story
            </NavLink>
          </li>
          <li>
            <NavLink
              className={({ isActive }) => {
                return isActive ? styles.active : styles.inactive;
              }}
              to="/vote"
            >
              Vote
            </NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default MainNavigation;
